module.exports = __webpack_public_path__ + "static/media/patProjectBlueLightningLogo.35c549a2.png";